import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {NgIf} from "@angular/common";

//Components
import {NavbarComponent} from "../navbar/navbar.component";
import {TopNavbarComponent} from "./top-navbar/top-navbar.component";

//Services
import {RequestMethodsService} from "@services/request/request-methods.service";
import {GlobalSubscriptionService} from "@services/subscriptions/global-subscription.service";
import {CityService} from "@services/city/city.service";
import {ComponentService} from "@services/components/component.service";
import {BrowserService} from "@services/components/browser.service";
import {BottomSheetDialogService} from "@services/bottom-sheet-dialog/bottom-sheet-dialog.service";
import {AuthService} from "@services/auth/auth.service";
import {IsInGeofenceService} from "@services/is-in-geofence/is-in-geofence.service";
import {ConfirmationDialogService} from "@services/confirmation-dilog/confirmation-dilog.service";
import {BasketService} from "@services/basket/basket.service";

//Constants
import {MobileNavigationBackButtonTypeEnum} from "@interfaces/components/enums/navigation-back-button-type.enum";
import {
  ShowDefaultAddressToChangeComponent
} from "../navbar/top-navbar/show-default-address-to-change/show-default-address-to-change.component";
import {filter} from "rxjs";
import {
  BottomNavbarForAddressSelectionComponent
} from "./bottom-navbar-for-address-selection/bottom-navbar-for-address-selection.component";

@Component({
  selector: 'app-mobile-navbar',
  templateUrl: './mobile-navbar.component.html',
  styleUrls: ['./mobile-navbar.component.scss'],
  standalone: true,
    imports: [NgIf, TopNavbarComponent, BottomNavbarForAddressSelectionComponent,
      ShowDefaultAddressToChangeComponent]
})
export class MobileNavbarComponent extends NavbarComponent implements OnDestroy, OnInit {
  readonly mobileNavigationBackButtonTypeEnum = MobileNavigationBackButtonTypeEnum;
  currentType: MobileNavigationBackButtonTypeEnum = MobileNavigationBackButtonTypeEnum.TWO_PART_HEADER_WITH_SEARCH_AND_ADDRESS_SELECTION

  constructor(
    public override requestService: RequestMethodsService,
    public override globalSubscriptionService: GlobalSubscriptionService,
    public override cityService: CityService,
    public override activatedRoute: ActivatedRoute,
    public override componentService: ComponentService,
    public override browserService: BrowserService,
    public override dialog: MatDialog,
    public override bottomSheetService: BottomSheetDialogService,
    public override authService: AuthService,
    public override router: Router,
    public override basketService: BasketService,
    public override confirmationDialogService: ConfirmationDialogService,
    public override mapService: IsInGeofenceService,
  ) {
    super(requestService,
      globalSubscriptionService, cityService, activatedRoute,
      componentService, browserService, dialog, bottomSheetService,
      authService, router, basketService, confirmationDialogService, mapService
    );
    this.activatedRoute.data.subscribe(data => {
      this.router.events
        .pipe(filter(e => e instanceof NavigationEnd))
        .subscribe(() => {
          this.detectCurrentTypeFromActivatedSnapshot();
        });
    });
  }

  ngOnInit(): void {
    this.detectCurrentTypeFromActivatedSnapshot();
  }

  detectCurrentTypeFromActivatedSnapshot(): void {
    let route = this.activatedRoute;

    while (route.firstChild) {
      route = route.firstChild;
    }

    const data = route.snapshot.data;

    if (!data['type']) return;

    this.currentType = data['type'] as MobileNavigationBackButtonTypeEnum;
  }

  showMobileAddressSelection = false;

  override openAsDialogForSelectAddress(): void {
    this.showMobileAddressSelection = true;
  }

  onMobileAddressConfirmed(data: { address: any } | { city: any }): void {
    this.showMobileAddressSelection = false;
    if ('city' in data) {
      this.onSelectChange({ city: data.city });
    } else {
      this.onSelectChange({ address: data.address });
    }
  }

  onMobileAddressClosed(): void {
    this.showMobileAddressSelection = false;
  }

  handleDialogClose(openAddressSelection: boolean): void {
    this.openDialogOrBottomSheetAddressSelect(openAddressSelection);
  }

  ngOnDestroy(): void {}

}
